import React from 'react';
import {Route, BrowserRouter, Switch } from 'react-router-dom'
import App from './App';



  export default function Routes() {
    return (
      <BrowserRouter>
        <div>
          <Route path='/'>
            <Switch>
               <Route path='/:city' component={App} />
            </Switch>
         </Route>
       </div>
     </BrowserRouter>
    );
  }



// WEBPACK FOOTER //
// ./src/routes.js